import { render, staticRenderFns } from "./ArticleBodyBottom.vue?vue&type=template&id=390c89a0"
import script from "./ArticleBodyBottom.vue?vue&type=script&lang=ts"
export * from "./ArticleBodyBottom.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBodyBottom.vue?vue&type=style&index=0&id=390c89a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports